<template>
  <div class="creative">
    <div class="creative_layout">
      <div class="left">
        <p
          style="font-size: 50px; margin-bottom: 40px; font-weight: 700"
          class="wow fadeInUp"
        >
          创意和技术支持
        </p>
        <p class="wow fadeInUp fontFamilyHt font24">
          我们的生态伙伴能力非凡，从创意构思到复杂的全案执行,全力推动虚拟制作从灵感到最终作品的高效转化。
        </p>
        <router-link
          v-if="isColor"
          :to="{ name: 'chCaseDemonstration', hash: '#specific-position' }"
          class="creative_call1"
          >联系我们</router-link
        >
        <router-link
          v-else
          :to="{ name: 'chCaseDemonstration', hash: '#specific-position' }"
          class="creative_call2"
          >联系我们</router-link
        >
      </div>
      <div class="rig">
        <img :src="imgUrl" alt="" class="wow fadeInUp" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    imgUrl: {
      type: String,
      default:
        "https://download.hecoos.com/enlightv/2025-17/9ff538df30d9ff4a3bf4a58d9bb069bf.png",
    },
    isColor: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped lang="scss">
/* 创意模块 */
.creative {
  width: 100%;

  padding: 110px 0;
  background-color: #000;
  color: #fff;
  box-sizing: border-box;
  /* 确保 padding 不会使元素超出宽度 */

  .creative_layout {
    display: flex;
    justify-content: space-between;
    width: 1239px;
    margin: 0 auto;
    .font24 {
      font-size: 24px;
      line-height: 37px;
      width: 480px;
      height: 120px;
      visibility: visible;
    }
    .rig img {
      width: 647px;
      height: 370px;
    }

    .creative_call1 {
      display: block;
      text-decoration: none;
      color: #fff;
      background-color: #7948ea;
      width: 151px;
      height: 50px;
      border-radius: 25px;
      text-align: center;
      line-height: 50px;
      font-size: 20px;
      margin-top: 70px;
      cursor: pointer;
      transition: all 0.3s ease;

      &:hover {
        // transform: scale(1.05);
        background-color: #fff;
        color: #7948ea;
      }
    }

    .creative_call2 {
      display: block;
      text-decoration: none;
      background-color: #147cf5;
      color: #fff;
      width: 151px;
      height: 50px;
      border-radius: 25px;
      text-align: center;
      line-height: 50px;
      font-size: 20px;
      margin-top: 70px;
      cursor: pointer;
      transition: all 0.3s ease;

      &:hover {
        // transform: scale(1.05);
        background-color: #fff;
        color: #147cf5;
      }
    }
  }
}
</style>
